import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { customBlogListReducer, CustomBlogListState } from "@waytek/Store/Custom/Blog/BlogListState";
import {
    customCheckoutReviewAndSubmitReducer,
    CustomCheckoutReviewAndSubmitState,
} from "@waytek/Store/Custom/Checkout/CheckoutReviewAndSubmitState";
import {
    customCheckoutShippingReducer,
    CustomCheckoutShippingState,
} from "@waytek/Store/Custom/Checkout/CheckoutShippingState";
import {
    customProductInformationReducer,
    CustomProductInformationState,
} from "@waytek/Store/Custom/Products/ProductInformationState";
import {
    customPurchasedProductsReducer,
    CustomPurchasedProductsState,
} from "@waytek/Store/Custom/Products/PurchasedProductsState";
import { customSavedCartModalReducer, CustomSavedOrderState } from "@waytek/Store/Custom/SavedOrder/SavedOrderState";
import { CustomCartState, customReducerCartReducer } from "@waytek/Store/CustomCartState";
import { customInvoiceHistoryReducer, CustomInvoiceHistoryState } from "@waytek/Store/CustomInvoiceHistoryState";
import { customOrderHistoryReducer, CustomOrderHistoryState } from "@waytek/Store/CustomOrderHistoryState";
import { CustomProductCartState, customReducerProductCartReducer } from "@waytek/Store/CustomProductCartState";
import { CustomPrintImagesState, customReducerPrintImages } from "@waytek/Store/State/PrintImages/PrintImagesState";
import {
    customSpendReportingReducer,
    CustomSpendReportingState,
} from "@waytek/Store/State/SpendReporting/SpendReportingState";
import { customTaxFieldsReducer, TaxFieldsState } from "@waytek/Store/State/TaxFields/TaxFieldsState";

export type CustomState = {
    name: string;
    blogList: CustomBlogListState;
    checkoutReviewAndSubmit: CustomCheckoutReviewAndSubmitState;
    checkoutShipping: CustomCheckoutShippingState;
    purchasedProducts: CustomPurchasedProductsState;
    customCartState: CustomCartState;
    customProductCartState: CustomProductCartState;
    customInvoiceHistoryState: CustomInvoiceHistoryState;
    customOrderHistoryState: CustomOrderHistoryState;
    spendReportingState: CustomSpendReportingState;
    productInformationState: CustomProductInformationState;
    taxFields: TaxFieldsState;
    printImages: CustomPrintImagesState;
    savedOrder: CustomSavedOrderState;
} & ApplicationState;

(reducers as any).blogList = customBlogListReducer;
(reducers as any).checkoutReviewAndSubmit = customCheckoutReviewAndSubmitReducer;
(reducers as any).checkoutShipping = customCheckoutShippingReducer;
(reducers as any).purchasedProducts = customPurchasedProductsReducer;
(reducers as any).customCartState = customReducerCartReducer;
(reducers as any).customProductCartState = customReducerProductCartReducer;
(reducers as any).customInvoiceHistoryState = customInvoiceHistoryReducer;
(reducers as any).customOrderHistoryState = customOrderHistoryReducer;
(reducers as any).spendReportingState = customSpendReportingReducer;
(reducers as any).productInformationState = customProductInformationReducer;
(reducers as any).taxFields = customTaxFieldsReducer;
(reducers as any).printImages = customReducerPrintImages;
(reducers as any).savedOrder = customSavedCartModalReducer;

type Reducers = {
    customBlogListReducer: typeof customBlogListReducer;
    customCheckoutReviewAndSubmitReducer: typeof customCheckoutReviewAndSubmitReducer;
    customCheckoutShippingReducer: typeof customCheckoutShippingReducer;
    customPurchasedProductsReducer: typeof customPurchasedProductsReducer;
    customReducerCartReducer: typeof customReducerCartReducer;
    customReducerProductCartReducer: typeof customReducerProductCartReducer;
    customInvoiceHistoryReducer: typeof customInvoiceHistoryReducer;
    customOrderHistoryReducer: typeof customOrderHistoryReducer;
    spendReportingState: typeof customSpendReportingReducer;
    customProductInformationReducer: typeof customProductInformationReducer;
    taxFields: typeof customTaxFieldsReducer;
    printImages: typeof customReducerPrintImages;
    savedOrder: typeof customCheckoutShippingReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
